import { Plus } from 'lucide-react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { T, TPlainTextKey } from '../../../../Translations';

interface Props {
  to: string;
  label: TPlainTextKey;
  intercomTarget: string;
}

function ActionLink({ to, label, intercomTarget }: Props) {
  return (
    <Link
      to={to}
      className="flex flex-shrink-0 items-center gap-2 rounded-md bg-primary px-5 py-2.5 text-primary-foreground transition-opacity hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-ring"
      style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
      data-intercom-target={intercomTarget}
    >
      <Plus className="h-5 w-5" aria-hidden="true" />
      <T kind={label} />
    </Link>
  );
}

export default observer(ActionLink);
